<template>
  <div class="footer_style">

     <div class="font_info">

<div class="user-settings-outer" style="float:right;line-height: 37px;cursor: pointer;font-size: 10px;">

          <Poptip placement="top" width="272" trigger="click" >
        <Icon type="md-settings" size="20" />
        <div class="user-settings-inner" slot="content" style="min-height:200px;">
             <Form :model="sysConfigForm" :label-width="80">


                      <FormItem :label="this.$t('is_auto_accept')">
                          <i-switch @on-change="changeAuto" v-model="sysConfigForm.autoAccept" :true-value="true" :false-value="false" >
                            <Icon type="md-checkmark" slot="open"></Icon>
                            <Icon type="md-close" slot="close"></Icon>
                          </i-switch>
                      </FormItem>
                  <FormItem :label="this.$t('auto_type')">
                    <Select size="small" v-model="sysConfigForm.acceptType"  @on-change="changeType" transfer>
                      <Option v-for="(item,index) in types" :key="index" :value="item.value" v-show="item.show">{{$t(item.label)}}</Option>
                    </Select>
                  </FormItem>

                  <FormItem :label="this.$t('display_control')" v-if="hasCotrolOrConfRole">

                    <span>{{$t('row')}}</span>
                    <Select size="small" v-model="row" style="width: 60px"  transfer>
                      <Option v-for="row in rcs" :key="`row-${row.name}`" :value="row.value" v-show="row.row">{{row.name}}</Option>
                    </Select>
                     <span>{{$t('col')}}</span>
                    <Select size="small" v-model="col" style="width: 60px" transfer>
                      <Option v-for="col in rcs" :key="`col-${col.name}`" :value="col.value" v-show="col.col">{{col.name}}</Option>
                    </Select>

                  </FormItem>
                  <FormItem :label="this.$t('system_theme')" :class="{ 'two-letter': $store.state.app.local ==='zh-CN' }">
                    <Select size="small" v-model="sysConfigForm.theme"  @on-change="changeTheme" transfer>
                    
                      <Option v-for="(item,index) in themes" :key="index" :value="item.value" v-show="item.show">{{$t(item.label)}}</Option>
                    </Select>
                  </FormItem>
                  <FormItem :label="this.$t('language')" :class="{ 'two-letter': $store.state.app.local ==='zh-CN' }">
                     <Language :langKey="langKey" :langType="'select'" v-if="$config.useI18n" @on-lang-change="setLocal"  :lang="local" />
               </FormItem>

              </Form>
        </div>
    </Poptip>
    </div>

     </div>

    <!-- <div class="font_info" style="padding-left: 30px" v-show="showAuto && showType"> -->
    <!-- <div class="font_info" style="padding-left: 30px" v-show="showType">

      {{$t('auto_type')}}
      <Select size="small" v-model="callType" style="width: 100px" @on-change="changeType">
        <Option v-for="(item,index) in types" :key="index" :value="item.value" v-show="item.show">{{$t(item.label)}}</Option>
      </Select>
    </div> -->
    <!-- <div class="font_info" :class="{'left':!showAuto}">{{$t("user_account")}}:{{account}}</div> -->
    <div class="font_info left" :class="{'left':!showAuto}">{{$t("user_account")}}:{{account}}</div>
    <div class="font_info">{{$t(info)}}</div>
    <template v-if="agent !== null && agent !== ''">
      <div class="font_info">{{$t("agent_extension")}}:{{agent}}</div>
    </template>
    <div class="font_info timer" v-if="false">{{$t("curr_time")}}:{{time}}</div>
    <div class="font_info">
      <label>{{$store.state.cacheData.isFusion ? $t('edition_title_fusion') : $t('edition_title')}}</label><label style="margin-left: 10px">{{version}}</label>
    </div>
  </div>
</template>

<script>
  import Language from "../language";
  import { mapMutations, mapActions} from 'vuex'
  import { getFormatDate } from '@/libs/tools'

  export default {
    name: 'FooterBar',
    components: {Language},
    props: {
      showAuto: {
        type: Boolean,
        default: false
      },
      supportVideo: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        //info: '服务器已连接',
        interval: null,
        time: getFormatDate('YYYY-mm-dd HH:MM:SS', new Date()),
        agent: '',
        version: this.$config.sys_version,
        account: this.$store.state.user.userName,
        showType: true,
        types: [
          {value: 'auto', label: 'webRtc_auto', show: true},
          {value: 'audio', label: 'webRtc_audio', show: true},
          {value: 'video', label: 'webRtc_video', show: true}
        ],
        themes: [
          {value: 'black', label: 'theme_black', show: true},
          {value: 'white', label: 'theme_white', show: true},
          {value: 'blue', label: 'theme_blue', show: true}
        ],
        theme: 'blue',
        row: 4,
        col: 5,
        rcs: [
          {value: 1, name: '1', row: false, col: false},
          {value: 2, name: '2', row: false, col: false},
          {value: 3, name: '3', row: true, col: true},
          {value: 4, name: '4', row: true, col: true},
          {value: 5, name: '5', row: true, col: true},
          {value: 6, name: '6', row: true, col: true},
          {value: 7, name: '7', row: false, col: true},
          {value: 8, name: '8', row: false, col: true},
          {value: 9, name: '9', row: false, col: true}
        ],
        sysConfigForm: {
          language: 'zh-CN',
          autoAccept: false,
          acceptType: 'auto',
          display_num: '4,5',
          theme: 'blue'
        },
        initUpdateCount: 0,//配置更新初始次数
        isUserFirstConfig: false,//是否是用户第一次配置

            }
        },
        methods:{
           ...mapMutations([
                'setLocal',
                'setCurrentMenu'
            ]),
            changeAuto(val) {
              if (val){
                this.types[0].show = false
                if (this.sysConfigForm.acceptType === 'auto'){
                  this.sysConfigForm.acceptType = 'audio'
                  this.$emit('callType','audio')
                }
              }else {
                this.types[0].show = true
              }
                this.$emit('autoAnswer',val)
            },
          changeType(value){
              this.$emit('callType',value)
          },
          changeTheme(value){
            // this.$Message.success('成功切换成'+value+'主题');
          },
        //获取用户设置信息
          getUserSysCommonConfig(tempJson) {

          }
    },
    created() {
      //获取数据库版本
      this.version = this.$store.state.app.webVersion
      //userId是指用户表中的ID字段
      let sys_user_id = this.$store.state.user.sys_user_id
      let tempJson = {sys_user_id: sys_user_id}
      //获取用户的行列配置
      this.getUserSysCommonConfig(tempJson)


    },
    computed: {
      displayControlConfig() {//默认 4,5
        return this.row + ',' + this.col
      },
      hasCotrolOrConfRole() {
        return this.$store.state.user.hasCotrolOrConfRole
      },
      langKey() {
        return this.$store.state.app.local
      },
      local() {
        return this.$store.state.app.local
      },
      info() {
        let info = 'serverunconnected'
        let socket = this.$store.state.websocket.WS
        let alive = false
        if (socket) {
          if (socket._alive) {
            alive = true
          }
        }
        if (this.$store.state.cacheData.inline && alive) {
          info = 'serverconnected'
        } else {
          info = 'serverunconnected'
        }
        return info
      }
    },
    watch: {
      supportVideo: {
        deep: true,
        immediate: true,
        handler(value) {
          if (!value) {
            this.showType = false
          } else {
            this.showType = true
          }
        }
      },
      displayControlConfig: {
        deep: true,
        //immediate: true,
        handler(value) {
          this.sysConfigForm.display_num = value
          this.$store.commit('setRow_column_display_num', value)
        }
      },
      sysConfigForm: {
        deep: true,
        //immediate: true,
        handler(value) {
          this.initUpdateCount++
          if ((this.isUserFirstConfig) || (!this.isUserFirstConfig && this.initUpdateCount > 1)) {//第二次以上才更新(老用户)，新用户第一次修改即入库
            //封装参数
            //userId是指用户表中的ID字段
            let sys_user_id = this.$store.state.user.sys_user_id
            let tempJson = {
              sys_user_id: sys_user_id,
              config_value: value
            }
            if (this.isUserFirstConfig) {
              //开始增加配置
              //this.addUserSysCommonConfig(tempJson)
            } else {
              //开始更新配置
              this.updateUserSysCommonConfig(tempJson)
            }

          }

        }
      }

    },
    mounted() {
      this.setLocal(this.$i18n.locale)
    },
    destroyed() {
      if (this.interval != null) {
        clearInterval(this.interval)
      }
    }
  }
</script>

<style lang="less">
@import "./footer-bar.less";
  .left{
    padding-left: 50px;
  }
  .user-settings-outer{
      .ivu-icon-md-settings{
        color: #FFF;
      }
      .user-settings-inner{
        .ivu-form-item {
            margin-bottom: 0px;
          .ivu-form-item-label{
                color: #515a6e;
                width: 80px;
              }
          .ivu-form-item-content{
                margin-left: 80px;
                .ivu-select{
                    .ivu-select-selection {
                        background-color: #fff;
                        color: #515a6e;
                        .ivu-select-arrow{
                          &::before{
                            color: #515a6e;
                          }
                      }
                      .ivu-avatar-circle{
                        border: 1px solid rgb(51, 51, 51);
                      }
                    }

                }
                .ivu-switch-checked {
                  border-color: #2d8cf0;
                  background-color: #2d8cf0;
                }



          }
          }
        .ivu-form-item.two-letter {
            margin-bottom: 0px;
          .ivu-form-item-label{
                color: #515a6e;
                width: 80px;
                letter-spacing: 27px;
                padding-left: 12px;
}
              }
          .ivu-form-item-content{
                margin-left: 80px;
          }
          }


      }

</style>



// WEBPACK FOOTER //
// src/components/main/components/footer-bar/footer-bar.vue